import { PaymentExchangeCurrency } from '@dev-fast/types';

export const AVAILABLE_WALLETS = [PaymentExchangeCurrency.USDT_TRC_20, PaymentExchangeCurrency.USDT_ERC_20];
